import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { FIRST_FIVE } from './salesData';
export function JourneySection() {
  return <section id="primeras-5" className="bg-white py-12 sm:py-16" data-id="element-120" data-mp="bnr3i02c9smr">
      <div className="mx-auto max-w-4xl px-5" data-id="element-121" data-mp="3t40pftwz4lbb">
        <div className="text-center" data-id="element-122" data-mp="1vv50nwcc0i0">
          <SectionTag className="bg-cream" data-id="element-123" data-mp="1wwjz3gh9750">Tus primeras 5</SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[22ch] font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2.2rem]" data-id="element-124" data-mp="pl7gjuf54knh">
            El método te da los <span className="text-gold" data-id="element-125" data-mp="glkagvbguqo3">5 lugares que tenés que llenar</span>.
          </h2>
        </div>

        <ol className="mt-6 grid gap-2 sm:grid-cols-2" data-id="element-126" data-mp="klus558mf5is">
          {FIRST_FIVE.map((slot, i) => <motion.li key={slot.num} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.24,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 4) * 0.04
        }} className="flex items-center gap-3 rounded-xl bg-cream px-3.5 py-3" data-id="element-127" data-mp="31b092cgxfjoa" data-mpi={i}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gold font-display text-[0.8rem] font-extrabold text-white" data-id="element-128" data-mp="38gi96964et4h">
                {slot.num}
              </span>
              <div className="min-w-0" data-id="element-129" data-mp="3ido45shuv49z">
                <h3 className="font-display text-[0.88rem] font-bold uppercase leading-tight tracking-tight text-charcoal" data-id="element-130" data-mp="3iccwvip7bee4">
                  {slot.title}
                </h3>
                <p className="mt-0.5 font-sans text-[0.8rem] leading-snug text-taupe" data-id="element-131" data-mp="3s2xvv78sekxk">{slot.desc}</p>
              </div>
            </motion.li>)}
        </ol>

        <p className="mx-auto mt-6 max-w-[52ch] text-center font-sans text-[0.86rem] font-medium leading-relaxed text-taupe" data-id="element-132" data-mp="4z03o8dtly78">
          Las 100 recetas están disponibles desde el primer día. El método te ayuda a elegir las 5 con
          las que tiene más sentido empezar.
        </p>
      </div>
    </section>;
}